import { SidebarDarkTheme } from './sidebar.dark-theme';
import { SidebarStyleType } from './sidebar.style-type';

export const SidebarLightTheme: SidebarStyleType = SidebarDarkTheme;
